import { FC } from "react";
import { Autocomplete, TextField } from "@mui/material";
import intl from "components/i18n/ReactIntlWrapper";

type RequestStatusSelectProps = {
  requestStatus: any;
  selectedStatus: any;
  handleStatusChange: any;
  isClearable: boolean;
};

const RequestStatusSelect: FC<RequestStatusSelectProps> = ({
  requestStatus,
  selectedStatus,
  handleStatusChange,
  isClearable,
}) => {
  if (requestStatus)
    requestStatus = requestStatus.filter((elem) => elem.label != "");

  const customStyles = {
    dropdownIndicator: (base: any) => ({
      ...base,
      cursor: "pointer",
    }),
    menuPortal: (base: any) => ({
      ...base,
      zIndex: 9999,
    }),
  };

  return (
    <Autocomplete
      id="requestStatus"
      options={requestStatus || []}
      getOptionLabel={(option) => intl.get(option.label)}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      value={
        requestStatus && selectedStatus != null
          ? requestStatus.find((status) => status.id === selectedStatus) || null
          : null
      }
      onChange={(event, newValue) => handleStatusChange(newValue)}
      loading={requestStatus == null}
      disabled={false}
      clearOnEscape={isClearable}
      sx={{ minWidth: 200 }}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder={intl.get("requestStatusSelect.placeholder")}
        />
      )}
    />
  );
};

export default RequestStatusSelect;
